import { availableGrooverBucketPrefixes } from '~/helpers/favorites/grooverBucket'

import type { ListNamePrefixes } from '~/helpers/favorites/grooverBucket'

export function stringIsGrooverBucketPrefix(
  string: string,
): string is ListNamePrefixes {
  return availableGrooverBucketPrefixes.includes(string as ListNamePrefixes)
}
